import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { TimeGrid } from '@/app/(main)/(pages)/busca/[slug]/_consts';
import { CarouselItem } from '@/components/ui/carousel.component';
import { Button } from '@/components/ui/button/button.component';
import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface ScheduleScheduleTimeGridProps {
  day: TimeGrid;
  scheduleType: ScheduleType;
}

export const scheduleTimeGridStyles = tv({
  slots: {
    container: ['flex flex-col justify-start', 'align-top gap-y-2'],
    slot: ['w-full text-wrap self-center'],
  },

  variants: {
    scheduleType: {
      [ScheduleType.SCHEDULED]: {
        container: 'basis-1/3 sm:basis-1/4 lg:basis-1/5',
        slot: 'h-12 w-20 sm:w-24 md:w-28 lg:w-32',
      },
      [ScheduleType.ARRIVAL_ORDER]: {
        container: 'basis-1/2 sm:basis-1/3 lg:basis-1/4',
        slot: 'h-20 md:h-14 w-28 sm:w-36 md:w-40 lg:w-40 ',
      },
      [ScheduleType.LABORATORIAL]: {
        container: 'basis-1/2 sm:basis-1/3 lg:basis-1/4',
        slot: 'h-20 md:h-14 w-28 sm:w-36 md:w-40 lg:w-40 ',
      },
    },
  },
});

type PossibleScheduleType = ScheduleType.SCHEDULED | ScheduleType.ARRIVAL_ORDER | ScheduleType.LABORATORIAL;

export function ScheduleTimeGridItem({ day, scheduleType }: ScheduleScheduleTimeGridProps) {
  const { container, slot } = scheduleTimeGridStyles();

  const timeGrid = scheduleType === ScheduleType.SCHEDULED ? day.times : day.timesPeriod;

  return (
    <CarouselItem key={day.day} className={container({ scheduleType: scheduleType as PossibleScheduleType })}>
      <div
        className="flex flex-col items-center bg-white w-[calc(100%+20px)] h-11 z-10 -ml-3"
        data-testid={`${DataTestIdEnum.SCHEDULE_TIME_GRID_DAY}-${day.day}`}
      >
        <p className="text-sm font-semibold">{day.weekday}</p>
        <p className="text-base text-gray-500" data-testid={DataTestIdEnum.SCHEDULE_TIME_GRID_DAY_LABEL}>
          {day.day}
        </p>
      </div>
      {timeGrid.map((time) => (
        <Button key={day.day + time} variant="secondary" className={slot({ scheduleType: scheduleType as PossibleScheduleType })}>
          {time}
        </Button>
      ))}
    </CarouselItem>
  );
}

interface EmptyColProps {
  scheduleType: ScheduleType;
}

export const EmptyCol = ({ scheduleType }: EmptyColProps) => {
  const { container } = scheduleTimeGridStyles();

  return (
    <CarouselItem className={container({ scheduleType: scheduleType as PossibleScheduleType })}>
      <div className="w-full" />
    </CarouselItem>
  );
};
